import * as React from 'react';

interface StringControlProps {
    value: string;
    onChange: (newValue: string) => void;
    label: string;
    id: string;
    multiline?: boolean;
}

export const StringControl = ({ value, onChange, label, id, multiline = false }: StringControlProps) => {
    const [currentValue, setCurrentValue] = React.useState(value);

    // Update local state when external value changes
    React.useEffect(() => {
        setCurrentValue(value);
    }, [value]);

    const handleBlur = () => {
        // Only trigger onChange when field is left, not on every keystroke
        if (currentValue !== value) {
            onChange(currentValue);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        // Allow Enter to trigger save for single-line inputs
        if (!multiline && e.key === 'Enter') {
            handleBlur();
        }
    };

    const commonStyles = {
        marginTop: '5px',
        padding: '5px',
        borderRadius: '3px',
        border: '1px solid #555',
        backgroundColor: '#333',
        color: 'white',
        fontFamily: 'monospace',
        fontSize: '12px',
        width: '100%',
        boxSizing: 'border-box' as const
    };

    return (
        <div className="control string-control" style={{ display: 'flex', flexDirection: 'column' }}>
            <label htmlFor={id}>{label}</label>
            {multiline ? (
                <textarea
                    id={id}
                    value={currentValue}
                    onChange={(e) => setCurrentValue(e.target.value)}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown}
                    rows={4}
                    style={{
                        ...commonStyles,
                        resize: 'vertical',
                        minHeight: '60px'
                    }}
                />
            ) : (
                <input
                    type="text"
                    id={id}
                    value={currentValue}
                    onChange={(e) => setCurrentValue(e.target.value)}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown}
                    style={commonStyles}
                />
            )}
        </div>
    );
}; 